import React, { Dispatch, SetStateAction } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Colors from '../../../constants/Colors';
import CheckBoxItem from '../../../components/CheckBoxItem';
import ScrollViewStyled from '../../../components/ScrollViewStyled';

// eslint-disable-next-line no-shadow
export enum AssetProperty {
  // eslint-disable-next-line no-unused-vars
  NAME = 'Name', IMAGE = 'Image', ID = 'ID', TEMPLATE = 'Template', LOCATION = 'Location',
  // eslint-disable-next-line no-unused-vars
  MANUFACTURER = 'Manufacturer', MODEL = 'Model', SERIAL = 'Serial number',
}

interface ColumnSelectionPaneProps {
  nameShown: boolean;
  imageShown: boolean;
  setImageShown: Dispatch<SetStateAction<boolean>>;
  locationShown: boolean;
  setLocationShown: Dispatch<SetStateAction<boolean>>;
  idShown: boolean;
  setIdShown: Dispatch<SetStateAction<boolean>>;
  templateShown: boolean;
  setTemplateShown: Dispatch<SetStateAction<boolean>>;
  modelShown: boolean;
  setModelShown: Dispatch<SetStateAction<boolean>>;
  manufacturerShown: boolean;
  setManufacturerShown: Dispatch<SetStateAction<boolean>>;
  serialShown: boolean;
  setSerialShown: Dispatch<SetStateAction<boolean>>;
}

const ColumnSelectionPane: React.FC<ColumnSelectionPaneProps> = ({
  nameShown, imageShown, setImageShown, locationShown, setLocationShown, idShown, setIdShown,
  templateShown, setTemplateShown, modelShown, setModelShown, manufacturerShown,
  setManufacturerShown, serialShown, setSerialShown,
}: ColumnSelectionPaneProps) => {
  const MAX_COLUMNS = 6;
  const selectedColumns = [
    nameShown,
    imageShown,
    idShown,
    templateShown,
    locationShown,
    modelShown,
    manufacturerShown,
    serialShown,
  ];
  const disableAddition: boolean = selectedColumns.filter(Boolean).length >= MAX_COLUMNS;

  return <View
    style={styles.container}
    testID='asset-columns-drop-down-menu'
  >
    <Text style={styles.title}>{`Columns (maximum of ${MAX_COLUMNS})`}</Text>
    <ScrollViewStyled>
      <CheckBoxItem
        toggled
        title={AssetProperty.NAME}
        style={styles.item}
      />
      <CheckBoxItem
        toggle={() => setImageShown(!imageShown)}
        toggled={imageShown}
        title={AssetProperty.IMAGE}
        style={styles.item}
        disabled={!imageShown && disableAddition}
      />
      <CheckBoxItem
        toggle={() => setIdShown(!idShown)}
        toggled={idShown}
        title={AssetProperty.ID}
        style={styles.item}
        disabled={!idShown && disableAddition}
      />
      <CheckBoxItem
        toggle={() => setTemplateShown(!templateShown)}
        toggled={templateShown}
        title={AssetProperty.TEMPLATE}
        style={styles.item}
        disabled={!templateShown && disableAddition}
      />
      <CheckBoxItem
        toggle={() => setLocationShown(!locationShown)}
        toggled={locationShown}
        title={AssetProperty.LOCATION}
        style={styles.item}
        disabled={!locationShown && disableAddition}
      />
      <CheckBoxItem
        toggle={() => setManufacturerShown(!manufacturerShown)}
        toggled={manufacturerShown}
        title={AssetProperty.MANUFACTURER}
        style={styles.item}
        disabled={!manufacturerShown && disableAddition}
      />
      <CheckBoxItem
        toggle={() => setModelShown(!modelShown)}
        toggled={modelShown}
        title={AssetProperty.MODEL}
        style={styles.item}
        disabled={!modelShown && disableAddition}
      />
      <CheckBoxItem
        toggle={() => setSerialShown(!serialShown)}
        toggled={serialShown}
        title={AssetProperty.SERIAL}
        style={styles.item}
        disabled={!serialShown && disableAddition}
      />
    </ScrollViewStyled>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 8,
    width: 268,
    height: 274,
    backgroundColor: '#FFF',
    position: 'absolute',
    end: 0,
    top: -40,
  },
  title: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlue500,
    letterSpacing: 0,
    paddingHorizontal: 12,
    paddingVertical: 9,
    borderBottomWidth: 1,
    borderBottomColor: Colors.light.hereworksBlue100,
  },
  item: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
});

export default ColumnSelectionPane;
